export interface AiScrubAccessRoles {
  isAdmin: boolean;
  isGroupLead: boolean;
  isAwardLead: boolean;
  isAwardNominationReviewer: boolean;
}

export function canStartAiScrub(roles: AiScrubAccessRoles): boolean {
  return roles.isAdmin || roles.isGroupLead || roles.isAwardLead || roles.isAwardNominationReviewer;
}
